<template lang="pug">
	.project-preview-mini(v-if="showed" v-pseudo-modal="'project-preview'" :style="{top: top + 'px', left: left + 'px', opacity: opacity}")
		.title-project-preview(v-if="project") {{project.title || Project.getTitle(project)}}
		.triangle

</template>

<script>

	import Screen 			from './../../mixins/screen';

	export default {
		name: "ProjectPreviewMini",
		mixins: [Screen],
		screen: {
			events: {
				"Show Project Preview": function(project, e, el) {

					this.project = project;

					this.update();

					let rect = el.getBoundingClientRect();

					this.top = rect.top + rect.height / 2 - 15;
					this.left = rect.width;
					this.opacity = 0;

					clearTimeout(this.opacityTimeout);
					this.opacityTimeout = setTimeout(() => {
						this.animateShow();
					}, 300);

					Broadcast.call("Pseudo Modal Show", ["project-preview"]);

				},
				"Hide Project Preview": function() {

					this.project = null;

					clearTimeout(this.opacityTimeout);

					this.update();

					Broadcast.call("Pseudo Modal Hide", ["project-preview"]);

				}
			}
		},
		data() {

			this.project = null;

			return {
				showed: true,
				top: 0,
				left: 0,
				opacity: 0
			};

		},
		computed: {

		},
		methods: {
			collectData() {



			},
			animateShow() {

				this.opacity = 1;
				this.update();

			}
		}
	}
</script>

<style lang="sass">

	.project-preview-mini
		position: absolute
		z-index: 10000
		top: 0
		left: 0
		border-radius: 0.25rem
		padding: 0.25rem
		border: 1px solid #23282c
		box-shadow: 0 0 10px rgba(0, 0, 0, 0.5)
		background-color: #73818f
		width: auto
		transition: opacity 0.2s

		.title-project-preview
			color: white
			padding: 0 5px

		.triangle
			width: 0
			height: 0
			border-width: 8px 8px 8px 0
			border-color: transparent #73818f transparent transparent
			border-style: solid
			position: absolute
			left: -5px
			top: 7px

</style>
